/**
 * If the user is navigating to a route which should have a projectId, but doesn't, fix it
 */

import { stripAuthCallbackHash } from '#core/utils/auth-callback'
import { resolveProjectRoute } from '#core/utils/project-id'
import { createLogger } from '#logger'

const logger = createLogger('project-id middleware')

export default defineNuxtRouteMiddleware((to, from) => {
  // Skip during SSR
  if (import.meta.server) {
    return
  }

  const auth = useAuth()

  const resolution = resolveProjectRoute({
    path: to.path,
    allowPreLogin: Boolean(to.meta.allowPreLogin),
    preservePublicPath: Boolean(to.meta.preservePublicPath),
    fromProjectId: Array.isArray(from.params.projectId) ? from.params.projectId[0] : from.params.projectId,
    authProjectId: auth.project?.id,
    isLoggedIn: auth.isLoggedIn,
  })

  if (resolution.action === 'scope') {
    logger.debug('Adding projectId to requested route', { path: to.path })
    return navigateTo({ path: resolution.path, query: to.query, hash: stripAuthCallbackHash(to.hash) })
  }

  if (resolution.action === 'landing') {
    logger.debug('User not logged in, redirecting settings route to the landing page', { path: to.path })
    return navigateTo('/')
  }

  if (resolution.action === 'login') {
    logger.debug('User not logged in, redirecting to login for project-scoped route', { path: to.path })
    auth.setRedirectTo(to.fullPath)
    return navigateTo('/login')
  }
})
